import React, { useEffect, useState } from 'react'
import useTrans from '../../../hooks/useTrans'
import { NewProdottoCard } from '../../molecules'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useSelector } from 'react-redux'
import { HOMEPAGE_DATA, PRODOTTI_VISTI } from '../../../utils/endpoint'
import { useRouter } from 'next/router'
import { api } from '../../../utils'
import * as Sentry from '@sentry/browser'

const Correlati = () => {
  return (
    <div className="w-container">
      <div
        style={{
          maxWidth: '100%',
        }}
      >
        <ProdottiSimili />
        {/* <LeNostreScelte /> */}
        <VistiDiRecente />
      </div>
    </div>
  )
}

export default Correlati

export const ProdottiSimili = () => {
  const t = useTrans()
  const router = useRouter()
  const [prodotti, setProdotti] = useState([])

  useEffect(() => {
    api
      .get('prodotti/' + router?.query?.slug?.[0] + '/simili/', {
        params: {
          lang: router.locale,
        },
      })
      .catch((err) => {
        console.log(err)
        Sentry.captureException(err)
      })
      .then((prodottiSimili) => setProdotti(prodottiSimili?.data))
    
  }, [])

  return <SliderProdotti title={t('Potrebbero interessarti anche')} prodotti={prodotti} noShallow />
}

export const LeNostreScelte = () => {
  const t = useTrans()
  const router = useRouter()
  const [prodotti, setProdotti] = useState([])

  useEffect( () => {
    api
      .get(HOMEPAGE_DATA, {
        params: {
          lang: router.locale,
        },
      })
      .catch((err) => {
        console.log(err)
        Sentry.captureException(err)
      })
      // ? Attualmente ritorno i Best Seller mostrati in HomePage
      .then((homepageDataResponse) => setProdotti(homepageDataResponse?.data?.best_seller[0]?.prodotti_categoria))
  }, [])

  return (
    <SliderProdotti
      title={t('Le nostre scelte')}
      prodotti={prodotti?.slice(0, 16) || []}
      noShallow
    />
  )
}

export const VistiDiRecente = () => {
  const t = useTrans()
  const router = useRouter()
  const [prodotti, setProdotti] = useState([])

  useEffect( () => {
    api
      .get(PRODOTTI_VISTI, {
        params: {
          lang: router.locale,
          codice: router?.query?.slug?.[0],
        },
      })
      .catch((err) => {
        console.log(err)
        Sentry.captureException(err)
      })
      .then((response) => setProdotti(response?.data))
  }, [])

  return (
    <SliderProdotti
      title={t('Visti di recente')}
      prodotti={prodotti?.slice(0, 16) || []}
      noShallow
    />
  )
}

export const SliderProdotti = ({ prodotti, title, noShallow }) => {
  const { utente } = useSelector((state) => state?.utente)
  return prodotti?.length > 0 ? (
    <div className="w-container" style={{ margin: '35px 0px' }}>
      <p
        className="homepage_template__section-title"
        style={{ textAlign: 'center', marginBottom: 15 }}
      >
        {title}
      </p>

      <div className="swiper--with-pagination swiper--lateral-padding">
        <Swiper
          navigation={true}
          pagination={{
            clickable: true
          }}
          modules={[A11y, Navigation, Pagination]}
          spaceBetween={48}
          slidesPerView={4}
          breakpoints={{
            320: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            991: {
              slidesPerView: 4,
            },
          }}
        >
          {prodotti?.map((prodotto, index) => {
            return (
              <SwiperSlide key={prodotto?.id}>
                <NewProdottoCard
                  prodotto={prodotto}
                  utente={utente}
                  noShallow={noShallow}
                  index={index}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </div>
  ) : null
}
